import type { SupabaseClient } from "@supabase/supabase-js";
import { cleanCPF } from "@/lib/cpf-validator";

/**
 * Retorna o id de outro paciente do mesmo profissional com o mesmo CPF (11 dígitos), ou null.
 */
export async function findOtherPatientIdWithSameCpf(
  supabase: SupabaseClient,
  ownerId: string,
  cpfRaw: string,
  excludePatientId?: string | null
): Promise<string | null> {
  const digits = cleanCPF(cpfRaw);
  if (digits.length !== 11) return null;

  let q = supabase
    .from("patients_onboarding")
    .select("id")
    .eq("owner_id", ownerId)
    .eq("cpf", digits)
    .limit(1);

  if (excludePatientId) {
    q = q.neq("id", excludePatientId);
  }

  const { data, error } = await q.maybeSingle();
  if (error && error.code !== "PGRST116") {
    throw new Error(error.message);
  }
  return data?.id ?? null;
}
